/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Button/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Button({
  children,
  viewPath = "/DesignSystem/Button",
  alignSelf = "flex-end",
  id,
  isDisabled,
  marginLeft = 8,
  marginTop = 25,
  onClick,
  paddingLeft = 15,
  paddingRight = 15,
  isSelected,
  text = "Press Return To Continue"
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<button
  data-testid="Button.Button:1"
  data-view-path={viewPath}
 id={id}
 disabled={isDisabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--as-1-2mwm5H': alignSelf,'--ml-3-2mwm5H': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-4-2mwm5H': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--pl-5-2mwm5H': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-6-2mwm5H': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--bc-2-2mwm5H': isHovered ? "rgba(0,147,201, 0.21)" : "rgba(0,147,201, 0.83)",'--o-7-2mwm5H': isBefore ? 0 : 1}}
 className={`views-block ${styles.Button1}`}
>
<span
  data-testid="Button.Text"
  data-view-path={viewPath}
 style={{'--c-8-2mwm5H': isHovered ? "rgba(0,147,201, 0.83)" : "#ffffff"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 onPress={onClick}
 keys="enter"
/>
</button>
{children}
</React.Fragment>)
}